import { render, staticRenderFns } from "./ModalEditChapter.vue?vue&type=template&id=88ce7ff4&scoped=true&"
import script from "./ModalEditChapter.vue?vue&type=script&lang=js&"
export * from "./ModalEditChapter.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditChapter.vue?vue&type=style&index=0&id=88ce7ff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ce7ff4",
  null
  
)

export default component.exports